import { render, staticRenderFns } from "./SellSetting.vue?vue&type=template&id=51868a7a&"
import script from "./SellSetting.vue?vue&type=script&lang=js&"
export * from "./SellSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports